import { z } from 'zod';

import { documentDataSchema } from '@/features/ui/DocumentsData/model/schemas';

export const technicalConditionDataSchema = z.object({
  confirmTechnicalConditionDocument: documentDataSchema,
});
